import { render, staticRenderFns } from "./AdminUsersAdmin.vue?vue&type=template&id=52d0e546"
import script from "./AdminUsersAdmin.vue?vue&type=script&lang=js"
export * from "./AdminUsersAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports